export default __webpack_public_path__ + "static/media/cash_blue.b08a62fe.svg";